import Vue from 'vue';

const highlightSelectedRange = (lowerBound, upperBound) => {

	/* 
		The functions has a misleading name. This function does not yet highlight a range.
		It selects those datapoints that shall be highlighted given a range.

		This functions accepts the two highlight arrays as parameters.
		These are global variables but this *.js file does not have acess to the context.
		Thus, the information needs to be passed into the function using parameters.
		And the updated arrays need to be returned so that the calling component can update the global variables.
		
		This function uses the ranges (lower bound and upper bound) set by the user.
		The function pushes those values from the globalTempHighlightArray into the globalHighlightArray that
		(a) correspond to the correct time slice
		(b) have values above the lower bound 
		(c) have values below the upper bound

		This function returns updated globalTempHighlightArray and globalHighlightArray that need to be updated by the calling component.
	*/
	
	// Why this condition? What if the array was empty?

	// console.log('lowerBound / upperBOund', lowerBound + ' ' + upperBound)
	//console.log(Vue.prototype.$globalTempHighlightArray.length)

	if (Vue.prototype.$globalTempHighlightArray.length > 0) {

		
		// Get the time slice that the user wants to see
		let selectedTimeSlice = Vue.prototype.$globalSharedData.selectedPeriod;

		//console.log('selectedTimeSlice', selectedTimeSlice)
		//console.log('globalTempHighlightArray[selectedTimeSlice]', Vue.prototype.$globalTempHighlightArray[selectedTimeSlice])

		let tempArray = []; // this will become the new globalHighlightArray

		if(lowerBound < upperBound) {
			// Normal case: lower bound is below upper bound
			
			for (let i = 0; i < Vue.prototype.$globalTempHighlightArray[selectedTimeSlice].length; i++) {
				if((Vue.prototype.$globalTempHighlightArray[selectedTimeSlice][i] >= lowerBound) && (Vue.prototype.$globalTempHighlightArray[selectedTimeSlice][i] <= upperBound )){
					tempArray.push(1);
				} else {
					tempArray.push(0);
				}
			}
			// console.log('temparray', tempArray)

			// The globalHighlightArray has the length of the sample size (e.g. 10000)
			// It contains values of 0 or 1 to indicate if the sample is within range or not
			Vue.prototype.$globalHighlightArray = [...tempArray];

			// console.log('Vue.prototype.$globalHighlightArray', Vue.prototype.$globalHighlightArray)

		} else if (lowerBound > upperBound) {
			// Unusual case: lower bound is above upper bound
			// This means we select the outer area of the distribution

			for (let i = 0; i < Vue.prototype.$globalTempHighlightArray[selectedTimeSlice].length; i++) {
				if((Vue.prototype.$globalTempHighlightArray[selectedTimeSlice][i] >= lowerBound) || (Vue.prototype.$globalTempHighlightArray[selectedTimeSlice][i] <= upperBound )){
					tempArray.push(1);
				} else {
					tempArray.push(0);
				}
			}
			// console.log('temparray', tempArray)
			
			Vue.prototype.$globalHighlightArray = [...tempArray];

			//console.log('Vue.prototype.$globalHighlightArray', Vue.prototype.$globalHighlightArray)

		} else {

			Vue.prototype.$eventHub.$emit("showModal", 
			{
				isModalShown: true, 
				modalData: {
					textAsHTML: 'Please add different values for lower and upper bound.',
					type: 'information',
					title: 'Identical values'
				}
			});
		}
  }
}

export default highlightSelectedRange;
